/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import queryString from "query-string";
import { useSelector } from "react-redux";
import { isEmpty } from "lodash";
import { permissionCheck } from "../../../utils/permission";

import PageHeader from "../../../components/PageHeader";
import CategoryList from "./CategoryList";
import CategorySedttings from "./CategorySettings";

const Category = (props) => {
  const history = useHistory();
  const { permissions } = useSelector(
    (store) => ({
      permissions: store.Profile.permissions,
    }),
  );
  const [activeTab, setActiveTab] = useState('list');
  const [targetPermission, setTargetPermission] = useState(null)

  useEffect(() => {
    if (!isEmpty(permissions)) {
      const permission = permissions.find(p => p.code === 'FUND_CLAIM_OBLIGATION')
      setTargetPermission(permission)
      if (isEmpty(permission)) {
        permissionCheck(history, "FUND_CLAIM_OBLIGATION")
      }
    }
  }, [permissions])

  const _setActiveTab = (value) => {
    history.push(`/funds/categories?tab=${value}`);
  };

  const tabList = [
    {
      label: "카테고리",
      action: _setActiveTab,
      value: 'list',
    },
    {
      label: "매출원가코드 설정",
      action: _setActiveTab,
      value: 'settings',
    },
  ];

  useEffect(() => {
    const query = queryString.parse(history.location.search);
    setActiveTab(query.tab || tabList[0].value);
  }, [history.location]);

  return (
    !isEmpty(targetPermission) && (
    <>
      <PageHeader
        title={ "카테고리" }
        activeTab={activeTab}
        tabList={tabList}
      // buttons={headerButtons}
      />
      {activeTab === "list" && <CategoryList></CategoryList>}
      {activeTab === "settings" && <CategorySedttings></CategorySedttings>}
    </>
    )
  )
};

export default Category;
